// src/hooks/useSubscription.js
import { useState } from 'react';
import profilApi from '../api/profilApi';

export const useSubscription = () => {
  const [isSubscription, setIsSubscription] = useState(false);
  // const [isTest, setIsTest] = useState(false);

  const checkSubscription = async (userEmail, setIsStart) => {
    try {
      if (!userEmail) return;
      const response = await profilApi.fetchUserData(userEmail);
      // const { subscriptionType, test, testall } = response.data;
      const { subscriptionType } = response.data;

      // setIsTest(test);
      setIsSubscription(!!subscriptionType);
      // if (setIsStart) setIsStart(!testall);
    } catch (error) {
      console.error('Ошибка проверки подписки:', error);
    }
  };

  // return { isSubscription, isTest, checkSubscription };
    return { isSubscription, checkSubscription };
};

